import {
  TranscriptionSession,
  TranscriptionSessionStatus
} from '@/types/transcriptionSessionTypes';

/**
 * Format time from milliseconds to HH:MM:SS format
 * Always shows hours, even when 00:00:00
 */
export const formatTime = (milliseconds: number): string => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Determine session status label from canonical enum
 */
export const getSessionStatus = (
  isRecording: boolean,
  _analysisComplete: boolean,
  _hasStartedRecording: boolean,
  _sessionId: string | null,
  sessionData?: TranscriptionSession | null,
  isStarting?: boolean,
  currentProcessingStage?: string
): string => {
  if (isStarting) return 'Preparing...';

  // Handle both string and numeric status values from backend
  const status = sessionData?.status;

  // Convert string status to enum value for comparison
  let statusEnum: TranscriptionSessionStatus;
  if (typeof status === 'string') {
    switch (String(status).toLowerCase()) {
      case 'draft':
        statusEnum = TranscriptionSessionStatus.Draft;
        break;
      case 'recording':
        statusEnum = TranscriptionSessionStatus.Recording;
        break;
      case 'processing':
        statusEnum = TranscriptionSessionStatus.Processing;
        break;
      case 'pendingapproval':
        statusEnum = TranscriptionSessionStatus.PendingApproval;
        break;
      case 'approved':
        statusEnum = TranscriptionSessionStatus.Approved;
        break;
      case 'rejected':
        statusEnum = TranscriptionSessionStatus.Rejected;
        break;
      default:
        statusEnum = TranscriptionSessionStatus.Draft;
    }
  } else {
    statusEnum = status as TranscriptionSessionStatus;
  }

  switch (statusEnum) {
    case TranscriptionSessionStatus.Draft:
      return 'Draft';
    case TranscriptionSessionStatus.Recording:
      return 'Recording';
    case TranscriptionSessionStatus.Processing:
      return currentProcessingStage
        ? `Processing (${currentProcessingStage})`
        : 'Processing';
    case TranscriptionSessionStatus.PendingApproval:
      return 'Pending Approval';
    case TranscriptionSessionStatus.Approved:
      return 'Approved';
    case TranscriptionSessionStatus.Rejected:
      return 'Rejected';
    default:
      return isRecording ? 'Recording' : 'Draft';
  }
};

